import { useSyncExternalStore } from 'react';

/** Mostrar la zona de strike (y dónde cruzó la bola) para ver por qué fue strike o bola. Ajustes; activada por defecto. */
const KEY = 'sportsarena.strikeZone';
let on = (() => {
  try {
    return typeof window === 'undefined' || localStorage.getItem(KEY) !== '0';
  } catch {
    return true;
  }
})();
const listeners = new Set<() => void>();
export const getStrikeZone = (): boolean => on;
export const setStrikeZone = (v: boolean): void => {
  on = v;
  try {
    localStorage.setItem(KEY, v ? '1' : '0');
  } catch {
    /* sin almacenamiento */
  }
  listeners.forEach((l) => l());
};
export const useStrikeZone = (): boolean =>
  useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => listeners.delete(l);
    },
    getStrikeZone,
    getStrikeZone
  );
